<script setup lang="ts">
import {QBtn, useDialogPluginComponent} from "quasar";
import NamaCommon, {NamaAxiosRequestConfig} from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import {onMounted, ref} from "vue";
import Translator from "@/utils/common/Translator.ts";
import PrintingParams = namaTypes.PrintingParams;

const {dialogRef, onDialogOK, onDialogCancel} = useDialogPluginComponent();

const props = defineProps({
  taskId: {
    type: String,
    required: true
  }
});
const pagesProgress = ref(0);
let killRequested = false;

onMounted(async () => {
  let asyncResult = await fetchReportTaskResult(props.taskId);
  if (!killRequested)
    onDialogOK(asyncResult);
})


async function fetchReportTaskResult(taskId: string) {
  let params: PrintingParams;
  do {
    let settings: NamaAxiosRequestConfig = {params: {taskId}, noLoadingIndicator: true};
    let response = await NamaCommon.namaFetch(NamaURLS.FetchReportTaskResult, settings);
    if (NamaCommon.isSuccess(response) && response.list && response.list[0]) {
      params = response.list[0];
      if (params && params.processed) {
        return response;
      } else {
        await NamaCommon.waitFor(500);
        pagesProgress.value = params.currentPagesCount ?? 0
      }
    } else {
      //show an error maybe?
      return {};
    }
  }
  while (!killRequested);
}

function onCancel() {
  killRequested = true;
  onDialogCancel()
}

</script>

<template>
  <q-dialog ref="dialogRef" @hide="onCancel" :persistent="true">
    <q-card class="tw-shadow-none dark:tw-bg-namaBackground-deep-dark tw-bg-namaBackground-deep-light !tw-rounded-none tw-min-w-[320px]">
      <q-card-section class="tw-flex tw-flex-col tw-items-center tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal">
        <q-circular-progress
          show-value
          class="tw-m-4"
          size="50px"
          indeterminate
          color="primary">
          {{ pagesProgress }}
        </q-circular-progress>
        <span v-text="Translator.translateId('pagesReady')"/>
      </q-card-section>
      <q-card-section class="tw-flex tw-flex-row tw-gap-4 tw-justify-center">
        <q-btn
          :label="Translator.translateId('cancel')"
          dense @click="onCancel"
          class="tw-bg-primary-light dark:tw-bg-primary-dark tw-text-white tw-text-base tw-font-normal tw-rounded-md tw-min-w-[90px]"/>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
